import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

export namespace DownloadIso27001SoaMutation {
  export type Output = {
    file: Blob;
  };
  function useMutationFn() {
    const downloadDocument = useInjectFeApiContext(
      FeApi.trustCenterCertificatesIso27001SoaRetrieve,
    );

    return async function mutationFn(): Promise<Output> {
      const result = await ok(downloadDocument({}));

      return { file: result };
    };
  }

  export function useMutation() {
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown>({
      mutationFn,
    });
  }
}
